import Conditions from "../../../../components/Conditions/Conditions";
import CardAccordion from "../CardAccordionMain/CardAccordion";
import styles from "./SudjelovanjeNaPredavanjima.module.css";

function SudjelovanjeNaPredavanjima({
  userId,
  data,
  evidentionUserID,
  setEvidentionData,
}) {
  const inputIds = [3, 7, 13, 12, 11];

  const programIdToName = {
    3: "Osobni razvoj (OR)",
    7: "Osobni razvoj-hibrid (eOR)",
    11: "Napredni terapeutski trening (TT)",
    12: "Terapeutski praktikum 2 (TP2)",
    13: "Terapeutski praktikum 1 (TP1)",
  };

  function filterProgramsAndFindMissingNames(data, inputIds, programIdToName) {
    const inputIdSet = new Set(inputIds);
    const foundIds = new Set();
    const filteredPrograms = {};

    if (data)
      for (const [programKey, value] of Object.entries(data)) {
        const items = Array.isArray(value) ? value : [value];
        const matchingItems = items.filter(
          (item) =>
            typeof item.programId === "number" && inputIdSet.has(item.programId)
        );

        for (const item of matchingItems) {
          foundIds.add(item.programId);
        }

        if (matchingItems.length > 0) {
          filteredPrograms[programKey] = matchingItems;
        }
      }
    if (foundIds.has(3)) {
      foundIds.add(7);
    } else if (foundIds.has(7)) {
      foundIds.add(3);
    }
    const missingProgramNames = inputIds
      .filter((id) => !foundIds.has(id))
      .map((id) => programIdToName[id]);

    return {
      filteredPrograms,
      missingProgramNames,
    };
  }

  const missingPrograms = filterProgramsAndFindMissingNames(
    data,
    inputIds,
    programIdToName
  );

  return (
    <div>
      <h1 className={styles.raniRazvojHeader}>
        Sudjelovanje na predavanjima i radionicama
      </h1>
      <p className={styles.raniRazvojDescription}>
        Za preuzimanje potvrde s ITP-a potrebno je ostvariti minimalan broj
        dolazaka na sva predavanja i radionice.
      </p>
      <p className={styles.raniRazvojDescription2}>
        Minimalan broj dolazaka za određeni program je vidljiv na dnu tablice
        programa.
      </p>
      <div className={styles.sudjelovanjeAccordion}>
        {data ? (
          Object.keys(data)
            .sort((a, b) => data[a].place - data[b].place)
            .map((property) => {
              const item = data[property];
              let isInteraktivnaPredavanja = false;
              let array = [];
              let brojPredavanja = 0;
              if (item?.interactiveLessons && item?.modules) {
                const interactiveLessonsWithType = item.interactiveLessons.map(
                  (lesson) => ({
                    ...lesson,
                    type: "interactive_lesson",
                  })
                );

                array.push(interactiveLessonsWithType);
                isInteraktivnaPredavanja = true;
                brojPredavanja = interactiveLessonsWithType.length;

                const modulesWithType = item.modules.map((module) =>
                  module?.map((m) => ({
                    ...m,
                    type: "regular_workshop",
                  }))
                );

                array.push(...modulesWithType);
              }
              if (item?.modules && !item?.interactiveLessons) {
                const modules = item.modules;
                const remainderModules = modules.slice(0);
                array.push(...remainderModules);
              }
              let attendedCount = 0;
              let totalCount = 0;
              let predavanjaAttendance = 0;
              let liveModulCount = 0;
              let totalLiveModulCount = 0;

              if (array) {
                array.forEach((module, index) => {
                  module?.forEach((item) => {
                    const isWorkshop =
                      item.name.includes("Radionica") ||
                      (!item.name.includes("predavanje") &&
                        !item.name.includes("interactive"));

                    const isLecture = !item.name.includes("Radionica");

                    const isLastArray = index === array.length - 1;

                    if (isLastArray && property.includes("eOR")) {
                      if (item.attendance && isWorkshop) {
                        liveModulCount++;
                        totalLiveModulCount++;
                      } else if (isWorkshop) {
                        totalLiveModulCount++;
                      }
                    } else {
                      if (item.attendance && isWorkshop) {
                        attendedCount++;
                        totalCount++;
                      } else if (isWorkshop) {
                        totalCount++;
                      }

                      if (item.attendance && isLecture) {
                        predavanjaAttendance++;
                      }
                    }
                  });
                });
              }

              return (
                <div key={property}>
                  {inputIds.includes(item.place) && (
                    <Conditions property={property} />
                  )}

                  <CardAccordion
                    evidentionUserID={evidentionUserID}
                    setEvidentionData={setEvidentionData}
                    userId={userId}
                    title={property}
                    modules={array}
                    isDisabled={!array || array.length === 0}
                    isRar={property.includes("RAR")}
                    isOR={property.includes("OR")}
                    isTP={property.includes("TP")}
                    isTT={property.includes("T5") || property.includes("T6")}
                    isEOR={property.includes("eOR")}
                    attendedCount={attendedCount}
                    totalAttendance={
                      property.includes("eOR") ? (
                        <>
                          Radionice ({attendedCount}/{totalCount})
                          <br />
                          Modul uživo ({liveModulCount}/{totalLiveModulCount})
                        </>
                      ) : (
                        `${attendedCount}/${totalCount}`
                      )
                    }
                    isInteraktivnaPredavanja={isInteraktivnaPredavanja}
                    infoText={`Kako bi ${
                      property.includes("TP1") || property.includes("TP2")
                        ? "završili program"
                        : "mogli preuzeti potvrdu o završenom programu"
                    }, polaznici su dužni doći na ${
                      property.includes("RAR")
                        ? 6
                        : property.includes("eOR")
                        ? 14
                        : property.includes("OR")
                        ? 17
                        : property.includes("TP1")
                        ? 6
                        : property.includes("TP2")
                        ? 7
                        : 25
                    }/${totalCount} radionica ${
                      property.includes("eOR")
                        ? "te na 5/6 modul uživo radionica "
                        : ""
                    }`}
                    showInfoText={true}
                    showEditBtn
                    errorFlag={
                      (property.includes("eOR") &&
                        (attendedCount < 14 || liveModulCount < 5)) ||
                      attendedCount <=
                        (property.startsWith("RAR")
                          ? 5
                          : property.startsWith("eOR")
                          ? 13
                          : property.startsWith("OR")
                          ? 16
                          : property.startsWith("TP1")
                          ? 5
                          : property.startsWith("TP2")
                          ? 6
                          : 24)
                    }
                  />
                </div>
              );
            })
        ) : (
          <h1>Nema podataka</h1>
        )}
        {missingPrograms.missingProgramNames?.map((val) => (
          <Conditions key={val} property={val} />
        ))}
      </div>
    </div>
  );
}

export default SudjelovanjeNaPredavanjima;
